// 










// import { useEffect, useState } from "react";
// import { httpsCallable } from "firebase/functions";
// import { functions } from "./firebase";

// export default function EmailDebug() {
//   const [logs, setLogs] = useState([]);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const load = async () => {
//       try {
//         const fn = httpsCallable(functions, "getMyLatestEmailLogs");
//         const res = await fn();

//         console.log("EMAIL LOGS:", res.data);
//         setLogs(res.data.logs || []);
//       } catch (err) {
//         console.error("FAILED:", err);
//         setError(err.message);
//       }
//     };

//     load();
//   }, []);

//   if (error) return <pre>Error: {error}</pre>;

//   return (
//     <div style={{ padding: 20 }}>
//       <h2>Email Logs (Debug)</h2>

//       {logs.length === 0 && <p>No email logs yet</p>}

//       {logs.map((log) => (
//         <div key={log.id} style={{ marginBottom: 10 }}>
//           <strong>{log.title}</strong>
//           <div>Status: {log.status}</div>
//           <div>Created: {log.created_at?.toDate?.().toString()}</div>
//         </div>
//       ))}
//     </div>
//   );
// }



















import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { auth } from "./firebase";

// Public pages
import LandingPage from "./screen/LandingPage";
import Signup from "./auth/Signup";
import Login from "./auth/Login";

// Protected pages (will appear inside the sidebar layout)
import Dashboard from "./screen/Dashboard";
import CreateLog from "./screen/CreateLog";
import LogDetail from "./screen/LogDetail";
import PublicLogView from "./screen/PublicLog";
import EmailSettings from "./screen/EmailSettings";

// Layout with sidebar
import Layout from "./Layout";
import Dashboard1 from "./screen/logs";
import DecisionHistory from "./screen/DecisionHistory";

// Private route guard
function PrivateRoute({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setUser(user);
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  if (loading) {
    return <div style={{ padding: "2rem", textAlign: "center" }}>Loading...</div>;
  }

  return user ? children : <Navigate to="/login" replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public routes - no sidebar */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/login" element={<Login />} />
        <Route path="/l/:publicId" element={<PublicLogView />} />

        {/* Protected routes – all inside the sidebar layout */}
        <Route
          path="/"
          element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }
        >
          {/* Nested routes render inside Layout's <Outlet /> */}
          <Route path="Dashboard" element={<Dashboard />} />
          <Route path="logs" element={<CreateLog/>} />
          <Route path="logs1" element={<Dashboard1/>} />
          <Route path="logs/:logId" element={<LogDetail />} />
          <Route path="settings/email" element={<EmailSettings />} />
          <Route path="/decision-history" element={<DecisionHistory />} />


          {/* Optional: you can add more settings pages later */}
          <Route path="settings" element={<EmailSettings />} />

          {/* Redirect /dashboard to /Dashboard (match your existing route) */}
          <Route path="dashboard" element={<Navigate to="/Dashboard" replace />} />
        </Route>

        {/* Fallback for unknown routes */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}